import { render, staticRenderFns } from "./ImagenDetalleArt.vue?vue&type=template&id=36c53c99&scoped=true&"
import script from "./ImagenDetalleArt.vue?vue&type=script&lang=js&"
export * from "./ImagenDetalleArt.vue?vue&type=script&lang=js&"
import style0 from "./ImagenDetalleArt.vue?vue&type=style&index=0&id=36c53c99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c53c99",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VCard,VCarousel,VCarouselItem,VCol,VContainer,VImg,VOverlay,VProgressCircular,VRow,VSheet,VSkeletonLoader,VSlideGroup,VSlideItem})
